<template>
  <footer
    :class="{
      'bg-gray-200': !props.reverseColor,
      'bg-gray-800 text-white': props.reverseColor,
    }"
  >
    <div class="container">
      <div class="grid xl:grid-cols-5 gap-6 py-12">
        <div class="xl:col-span-2">
          <router-link to="/">
            <img :src="settingsStore.siteLogo" class="h-8" />
          </router-link>
          <p class="text-gray-500/80 mt-5 lg:w-4/5">
            {{ settingsStore.siteDescription }}
          </p>
        </div>
        <div class="xl:col-span-3 col-span-4">
          <div
            class="flex flex-col sm:flex-row gap-6 flex-wrap justify-between"
          >
            <div
              v-for="(menuGroup, index) in menuStore.footerMenuGroups"
              :key="index"
            >
              <div class="flex flex-col gap-3">
                <h5 class="mb-3 uppercase">{{ menuGroup.GroupName }}</h5>
                <div
                  class="text-gray-500/80"
                  v-for="(menu, menuIndex) in menuGroup.Menus"
                  :key="menuIndex"
                >
                  <router-link :to="menu.Link">
                    <i
                      class="fa-solid text-primary/80 me-2"
                      :class="menu.Icon"
                    ></i>
                    {{ menu.Name }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-t py-6">
        <div class="grid sm:grid-cols-2 text-center sm:text-start gap-6">
          <div>
            <p class="text-gray-500/80 text-sm">
              {{ new Date().getFullYear() }} © {{ settingsStore.footerText }}
            </p>
          </div>
          <div class="sm:text-end">
            <span
              class="font-mono text-[10px] text-gray-500/50"
              data-build-tag
              :aria-label="`Derleme sürümü ${buildTag}`"
            >
              {{ buildTag }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useMenuStore } from "@/stores/menuStore";
import { useSettingsStore } from "@/stores/settingStore";
import { defineProps } from "vue";
const props = defineProps({
  reverseColor: Boolean,
});

const buildTag = process.env.VUE_APP_BUILD_TAG || "dev-local";
const menuStore = useMenuStore();
const settingsStore = useSettingsStore();
</script>
